export * from './montreal-smoked-meat';
